<form [formGroup]="form">
  <div class="request-form-container" *ngIf="!requestSubmitting && !requestSubmitted">
    <h1 class="mat-title" [translate]="'RequestDialogComponent:Concierge'">Concierge</h1>
    <p class="dialog-text">
      <span [translate]="'RequestDialogComponent:MessageALM'">
        Message a Lifestyle Manager if you need help making a special or immediate request, or call on</span
      >&nbsp;
      <a
        *ngIf="(customisableVariables | async).contact_number_general"
        href="tel:{{ (customisableVariables | async).contact_number_general }}"
        >{{ (customisableVariables | async).contact_number_general }}</a
      >
      <span
        *ngIf="
          (customisableVariables | async).contact_number_general &&
          (customisableVariables | async).toll_free_contact_number
        "
      >
        |
      </span>
      <a
        *ngIf="(customisableVariables | async).toll_free_contact_number"
        href="tel:{{ (customisableVariables | async).toll_free_contact_number }}"
        >{{ (customisableVariables | async).toll_free_contact_number }}</a
      >
    </p>

    <mat-divider class="dialog-divider"></mat-divider>

    <!-- Type -->
    <mat-form-field>
      <mat-select formControlName="type" [placeholder]="'RequestDialogComponent:TypeOfRequest' | translate" required>
        <mat-option value="entertainment"
          ><span [translate]="'RequestDialogComponent:Ent'">Entertainment</span></mat-option
        >
        <mat-option value="dining"><span [translate]="'RequestDialogComponent:Dining'">Dining</span></mat-option>
        <mat-option value="member_events"
          ><span [translate]="'RequestDialogComponent:MemberEvents'">Member Events</span></mat-option
        >
        <mat-option value="benefits"><span [translate]="'RequestDialogComponent:Offers'">Offers</span></mat-option>
        <mat-option value="travel"><span [translate]="'RequestDialogComponent:Travel'">Travel</span></mat-option>
        <mat-option value="other"><span [translate]="'RequestDialogComponent:Other'">Other</span></mat-option>
      </mat-select>
      <mat-error
        *ngIf="form.get('type').hasError('required')"
        [translate]="'PhoneNumberFormComponent:PhoneNumberTypeErrorMsg'"
      >
        Please select a type
      </mat-error>
    </mat-form-field>

    <!-- Date -->
    <mat-form-field>
      <input
        readonly
        formControlName="date"
        matInput
        [matDatepicker]="picker"
        [min]="startDate"
        (click)="picker.open()"
        (keyup.enter)="picker.open()"
        (keyup.space)="picker.open()"
        [placeholder]="'RequestDialogComponent:ChooseDate' | translate"
      />
      <mat-datepicker-toggle matSuffix [for]="picker" required>
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker [touchUi]="innerWidth < 640" #picker></mat-datepicker>
      <mat-error *ngIf="form.get('date').hasError('required')" [translate]="'RequestDialogComponent:ChooseDate'">
        Choose a date
      </mat-error>
    </mat-form-field>

    <!-- Detail -->
    <mat-form-field style="width: 100%" required>
      <textarea
        formControlName="detail"
        style="height: 100px"
        matInput
        [placeholder]="'RequestDialogComponent:RequestDetails' | translate"
      ></textarea>
      <mat-error *ngIf="form.get('detail').hasError('required')" [translate]="'RequestComponent:DetailsError'">
        Please provide some details about your request
      </mat-error>
    </mat-form-field>

    <!-- Button -->
    <div mat-dialog-actions class="request-button-group">
      <button aria-label="cancel" mat-raised-button (click)="closeDialog()">
        {{ 'RequestDialogComponent:Cancel' | translate }}
      </button>
      <button
        aria-label="send request"
        [disabled]="!form.valid"
        color="primary"
        mat-raised-button
        (click)="sendRequest()"
        cdkFocusInitial
      >
        {{ 'RequestDialogComponent:SendRequest' | translate }}
      </button>
    </div>
  </div>
</form>

<div *ngIf="requestSubmitting" class="submitting-data">
  <span>
    <p>
      <mat-spinner></mat-spinner>
    </p>
  </span>
</div>

<div *ngIf="requestSubmitted" class="submitting-data">
  <span>
    <h1 class="mat-title" [translate]="'RequestDialogComponent:RequestSubmittedTitle'">Request Submitted</h1>
    <p [translate]="'RequestDialogComponent:RequestSubmittedBody'">
      Thank you for your request, our team of experts has received it and will contact you shortly to discuss it in more
      detail.
    </p>

    <div mat-dialog-actions class="request-button-group">
      <div>
        <button aria-label="close" mat-raised-button (click)="closeDialog()">
          {{ 'RequestDialogComponent:Close' | translate }}
        </button>
      </div>
    </div>
  </span>
</div>
